export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6947.2b6909c0.jpg";